const routes = {
  '/': {
    code: 'main',
    '/unauthorized': {
      code: 'unauthorized',
    },
  },
}
export default routes
